import Cookies from "js-cookie";

import {theme} from 'antd';

interface InboxV2StylesOptions {
  hasScheduling?: boolean;
}

export const layout = Cookies.get("react-resizable-panels:layout:mail");
export const collapsed = Cookies.get("react-resizable-panels:collapsed");

export const defaultLayout = layout ? JSON.parse(layout.value) : undefined;
export const defaultCollapsed = collapsed ? JSON.parse(collapsed.value) : undefined;

export const useInboxV2Styles = (options: InboxV2StylesOptions = {}) => {
  const { hasScheduling = false } = options;

 const {
  token: {
    colorBgContainer,
    colorBgBase,
    borderRadiusSM,
    colorBorder,
    colorText,
    colorBorderSecondary,
  },
} = theme.useToken();

return{

 headerStyle: {
  color: colorText,
  minHeight: 50,
  height: "fit-content",
  backgroundColor: colorBgContainer,
  borderStyle: "solid",
  borderWidth: 0,
  padding: 3,
  lineHeight: 3,
  borderBottomWidth: 1,
  borderColor: colorBorderSecondary,
  overflow: "clip",
}  as React.CSSProperties,

 contentStyle:{
  minHeight: 120,
  color: colorText,
  backgroundColor: colorBgContainer,
  flex: 1,
  borderStyle: "solid",
  borderWidth: 0,
  padding: 3,
  borderBottomWidth: 1,
  borderColor: colorBorderSecondary,
} as React.CSSProperties,

threadContainerStyle:{
  minHeight: 120,
  color: colorText,
  backgroundColor: "#fdfdfd",
  flex: 1,
  borderStyle: "solid",
  borderWidth: 0,
  padding: 3,
  borderBottomWidth: 1,
  borderColor: colorBorderSecondary,
}  as React.CSSProperties,

PanelStyle: {
  display: "flex",
  flexDirection: "column",
  height: "calc(100vh - 54px)",
  backgroundColor: colorBgContainer,
}  as React.CSSProperties,

textingInputAreaStyle:{
  color: colorText,
  minHeight: hasScheduling ? 120 : 120,
  height: "fit-content",
  backgroundColor: colorBgContainer,
  borderStyle: "solid",
  borderWidth: 1,
  padding: 10,
  lineHeight: 3,
  borderBottomWidth: 1,
  borderColor: colorBorderSecondary,
  overflow: "visible",
}  as React.CSSProperties,

footerStyle:  {
  textAlign: "center",
  color: "#fff",
  backgroundColor: "#4096ff",
  height: "20px",
}  as React.CSSProperties,

layoutStyle : {
  height: "calc(100vh - 54px)",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  background: "#fff"
}  as React.CSSProperties
}
};
